const UNITS = [
  '',
  'satu',
  'dua',
  'tiga',
  'empat',
  'lima',
  'enam',
  'tujuh',
  'delapan',
  'sembilan',
  'sepuluh',
  'sebelas',
];

const convertToWords = (num: number): string => {
  if (num < 12) {
    return UNITS[num];
  }
  if (num < 20) {
    return `${convertToWords(num - 10)} belas`;
  }
  if (num < 100) {
    const remainder = num % 10;
    return `${convertToWords(Math.floor(num / 10))} puluh${
      remainder ? ` ${convertToWords(remainder)}` : ''
    }`;
  }
  if (num < 200) {
    return `seratus${num - 100 ? ` ${convertToWords(num - 100)}` : ''}`;
  }
  if (num < 1000) {
    const remainder = num % 100;
    return `${convertToWords(Math.floor(num / 100))} ratus${
      remainder ? ` ${convertToWords(remainder)}` : ''
    }`;
  }
  if (num < 2000) {
    return `seribu${num - 1000 ? ` ${convertToWords(num - 1000)}` : ''}`;
  }
  if (num < 1000000) {
    const remainder = num % 1000;
    return `${convertToWords(Math.floor(num / 1000))} ribu${
      remainder ? ` ${convertToWords(remainder)}` : ''
    }`;
  }
  if (num < 1000000000) {
    const remainder = num % 1000000;
    return `${convertToWords(Math.floor(num / 1000000))} juta${
      remainder ? ` ${convertToWords(remainder)}` : ''
    }`;
  }
  const remainder = num % 1000000000;
  return `${convertToWords(Math.floor(num / 1000000000))} milyar${
    remainder ? ` ${convertToWords(remainder)}` : ''
  }`;
};

export const numberToWords = (num: number): string => {
  if (num === 0) return 'nol';
  const words = convertToWords(Math.abs(Math.trunc(num)));
  return num < 0 ? `minus ${words}` : words;
};
